// import fireStore from "./firestore"


// const questionsCollection = fireStore.collection('questions')


function getQuestions() {
    return new Promise((res, rej) => {
        // questionsCollection.get()
        //     .then(querySnapshot => {
        //         // console.log(JSON.stringify(querySnapshot))
        //         console.log(querySnapshot._delegate._snapshot.docs.keyedMap.root.value.data)
        //     })
        res(QUESTIONS)
    })
}


let longContent = `
# Some title
Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt at, iusto ea, iure minima tempora, eaque autem cupiditate et reprehenderit praesentium consectetur veritatis! Eum vitae, inventore pariatur consequatur suscipit debitis nihil omnis molestiae. Voluptates repudiandae dolor iste porro omnis perferendis quasi corrupti obcaecati, molestias saepe hic laboriosam? Facilis, repellendus nihil.

## Second title
Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt at, iusto ea, iure minima tempora, eaque autem cupiditate et reprehenderit praesentium consectetur veritatis! Eum vitae, inventore pariatur consequatur suscipit debitis nihil omnis molestiae. Voluptates repudiandae dolor iste porro omnis perferendis quasi corrupti obcaecati, molestias saepe hic laboriosam? Facilis, repellendus nihil.
`


const QUESTIONS = [
    {
        slug: '1-question',
        title: "Some question",
        description: 'Some description',
        content: longContent,
        tagIds: [1, 2, 3]
    },
    {
        slug: '2-question',
        title: "Some question",
        description: "Some description",
        content: "this is content",
        tagIds: [1, 2, 3]
    },
    {
        slug: '3-question',
        title: "Some question",
        description: "Some description",
        content: "this is content",
        tagIds: [1, 2, 3]
    },
]


export default getQuestions
